<template functional>
  <a :href="`mailto:${props.email}`" :class="[data.class, data.staticClass]">
    {{ props.email }}
  </a>
</template>

<script>
export default {
  name: 'EmailLink',
  props: {
    email: {
      type: String,
      required: true,
    },
  },
};
</script>
